import React from 'react';
import './preloader.css';
import loading from './loading.gif';
const Preloader = () => (
    <div className="preloader">
        <div className="preloader-content">
            <img src={loading} alt="Loading"/>
            <p>Loading data...</p>
        </div>
    </div>
);

export default Preloader;